import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';
var Center = styled(Box).withConfig({
  componentId: "a71bfz-0"
})(["display:flex;width:100%;height:100%;place-items:center;place-content:center;"]);
export { Center };